import { fn, hash } from '@ember/helper';
import fuiSlider from 'wise-fui-modules/modifiers/fui-slider';
import FeelingEvasSliderComponent, {
  type FeelingEvasSlidersSignature
} from './component';

export default class FeelingEvasMoodSlider extends FeelingEvasSliderComponent<FeelingEvasSlidersSignature> {
  static override max = 10;
  static override min = 0;

  <template>
    {{! prettier-ignore }}
    <div
      class={{this.styles.slider}}
      ...attributes
      {{fuiSlider min=this.min
        max=this.max
        step=0.1
        start=@start
        onChange=@onChange
        autoAdjustLabels=false
        interpretLabel=(fn
          this.labels
          (hash
            0="<i class='meh outline large grey icon'></i>"
            100="<i class='angry outline red large icon'></i>"
          )
        )
      }}
    ></div>

    <div class={{this.styles.hints}}>
      <span class='ui small grey text'>niveau habituel ({{this.min}})</span>
      <span class='ui small grey text'>extrêmement irritable ({{this.max}})</span>
    </div>
  </template>
}
